// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20MVz","content":"styles_content__8KHEG","row":"styles_row__1UD5u","footer":"styles_footer__2QjnP","phraseLength":"styles_phraseLength__1Zs2I"};